module.exports = __webpack_public_path__ + "static/media/thumbs_lagodigital_9.c183ddce.jpg";